// src/components/SidebarTree.jsx
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SidebarTree.module.css';
import { UserContext } from '../context/UserContext';

const SidebarTree = ({ pages, onSelect, onDelete }) => {
  const navigate = useNavigate();
  const user = useContext(UserContext); // ✅ context now works

  const renderTree = (nodes, level = 0) => {
    return nodes.map((node) => (
      <div key={node.id} style={{ marginLeft: level * 15 }} className={styles.pageRow}>
        <div
          className={styles.pageLink}
          onClick={() => {
            navigate(`/view/${node.id}`);
            onSelect(node.id);
          }}
        >
          <div className={styles.pageTitle}>{node.title}</div>

          {user?.role === 'superAdmin' && (
            <div className={styles.iconGroup}>
              <span
                title="Edit"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/edit/${node.id}`);
                }}
                className={styles.iconBtn}
              >
                ✏️
              </span>
              <span
                title="Delete"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.(node.id);
                }}
                className={styles.iconBtn}
              >
                🗑️
              </span>
            </div>
          )}
        </div>

        {node.children && node.children.length > 0 && renderTree(node.children, level + 1)}
      </div>
    ));
  };

  return <div className={styles.sidebarTree}>{renderTree(pages)}</div>;
};

export default SidebarTree;
